import { FC } from "react";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { FullScreenDialog } from "../../../../components";
import TravelerPickerProviderV2 from "../../../../providers/TravelerPickerContextV2";
import StickyContainer from "../../Sticky/StickyContainer";
import TravelerPickerContent from "./TravelerPickerContent";
import TravelerPickerFooter from "./TravelerPickerFooter";
import TravelerPickerHeader from "./TravelerPickerHeader";
import {
  Employee,
  FlightNonEmployee,
  FormValues,
  HotelNonEmployee,
} from "./types";

type CommonProps = {
  visible: boolean;
  onClose(): void;
  employeeList: Employee[];
  divisionOptions: Array<{
    value: string;
    label: string;
  }>;
  recentPickEmployees: Employee[];
  AddEmployeeWidget?: FC<{ addSelectedEmployee: (employee: Employee) => void }>;
  permissions: {
    travelerPicker: {
      canBookNonEmployee: boolean;
      canBookForOwn: boolean;
      canBookForOthers: boolean;
      canCreateEmployee: boolean;
    };
  };
};

export type TravelerPickerProps = (
  | {
      type: "flight";
      onSubmit(value: FormValues<FlightNonEmployee>): void;
    }
  | {
      type: "hotel";
      onSubmit(value: FormValues<HotelNonEmployee>): void;
    }
) &
  CommonProps;

export default function TravelerPicker(props: TravelerPickerProps) {
  const { visible } = props;

  const { getValues } = useFormContext();
  const methods = useForm<FormValues<any>>({
    defaultValues: getValues(),
  });

  return (
    <TravelerPickerProviderV2 {...props}>
      <FormProvider {...methods}>
        <FullScreenDialog visible={visible}>
          <StickyContainer
            headerContent={<TravelerPickerHeader {...props} />}
            footerContent={<TravelerPickerFooter />}
            hasInsets
          >
            <TravelerPickerContent />
          </StickyContainer>
        </FullScreenDialog>
      </FormProvider>
    </TravelerPickerProviderV2>
  );
}
